import React from "react";
import { connect } from "react-redux";
import {
  registrarUsuario,
  editarUsuario
} from "../../components/usuario/UsuarioService";
import axios from "axios";
import { URL as URLService, getAuthorizationHeader, getAuthorizationHeaderUpload, aparienciaFirmaUsuario, admin, idEmpresa } from "../../constans/constants";
import Cookies from "universal-cookie";

import Resizer from "react-image-file-resizer";
import { logout } from "../login/SesionService";
import { validateForm } from "../../constans/validationUtils";
import validarImagen from "../seguridad/ValidadorImagen";
import DropzoneComponent from "../componentes/DropzoneComponent";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput, integrarConChkClick
} from '../../constans/form-error-utils';

export const obtenerIdEmpresa = () => {
  const cookies = new Cookies();
  return cookies.get("empresa");
};
export const esSesionAdmin = () => {
  const cookies = new Cookies();
  return cookies.get("admin") == "true";
};

class Usuario extends React.Component {
  constructor(props) {
    super(props);

    const { tipoAccion } = props.match.params;

    const originalHandleInput = this.handleInput;
    const originalChkClick = this.chkclick;

    this.handleInput = integrarConHandleInput(this, originalHandleInput);
    this.chkclick = integrarConChkClick(this, originalChkClick);

    this.state = {
      usuario: "",
      identificador: "",
      nombres: "",
      apellidos: "",
      cedula: "",
      celular: "",
      email: "",
      empresas: [],
      rolesxempresa: [],
      empresaSelect: -1,
      rolesSelect: {},
      id: "",
      nroPersonalIps: "",
      nroTrabajoMtess: "",
      errors: {
        usuario: null,
        identificador: null,
        nombres: null,
        apellidos: null,
        cedula: null,
        email: null,
        nroPersonalIps: null,
        nroTrabajoMtess: null,
        rolesSelect: null,
        empresaId: null
      },
      urlFirma: "",
      uriFirma: null,
      mostrarMensaje: false,
      mensaje: "",
      mensajeErrorAparienciaFirma: "",
      openPantallaCarga: false,

      showValidacion: false,
      erroresValidacion: null,

      errorFirma: "",
      severity: "success",

      mensajeFlash: "",
      mostrarMensajeFlash: false,
      mensajeFlashSeverity: "neutral",

      titulo: null,
      tipoAccion,
      showErrors: false
    };
    this.formRef = React.createRef();

  }

  reglasValidacionCampos = {
    usuario: [
      { required: true, message: 'Campo obligatorio' },
      { customValidator: (value, formData) => /^[a-zA-Z0-9._-]+$/.test(value), message: 'Se permiten sólo números, letras o los caracteres: -, . , _' },
    ],
    identificador: [
      { required: true, message: 'Campo obligatorio' },
      { customValidator: (value, formData) => /^\d+(-\d+)?$/.test(value), message: 'Inserte sólo números o un guion (-) entre ellos' },
    ],
    nombres: [
      { required: true, message: 'Campo obligatorio' },
      { customValidator: (value, formData) => /^[\p{L}\s]+$/u.test(value), message: "El nombre debe contener solo letras" }
    ],
    apellidos: [
      { required: true, message: 'Campo obligatorio' },
      { customValidator: (value, formData) => /^[\p{L}\s]+$/u.test(value), message: "El apellido debe contener solo letras" }
    ],
    cedula: [
      { required: true, message: 'Campo obligatorio' },
      { customValidator: (value, formData) => /^\d+(-\d+)?$/.test(value), message: 'Inserte sólo números o un guion (-) entre ellos' },

    ],
    email: [
      { required: true, message: 'Campo obligatorio' },
      { customValidator: (value, formData) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value), message: "Ingrese una dirección de email válida" }
    ],
    celular: [
      {
        customValidator: (value, formData) => {
          if (value === '')
            return true
          else
            return /^\d+$/.test(value)
        }, message: 'Inserte sólo números'
      },
    ],
    nroPersonalIps: [
      {
        customValidator: (value, formData) => {
          if (value === '')
            return true
          else
            return /^\d+$/.test(value)
        }, message: 'Inserte sólo números'
      },
    ],

    nroTrabajoMtess: [
      {
        customValidator: (value, formData) => {
          if (value === '')
            return true
          else
            return /^\d+$/.test(value)
        }, message: 'Inserte sólo números'
      },
    ]
  }


  setBackButton = () => {
    return esSesionAdmin() ? "/admin/usuarios" : "/administracion/usuarios"
  }


  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  obtenerRolesEmpresaAsignada = (empresaRoles) => {
    const arr = []
    arr.push(empresaRoles.find(elemento => elemento.id == idEmpresa()))
    return arr
  }

  validarCamposFormulario = () => {
    let { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    const valorOriginal = isValid;
    if (esSesionAdmin && this.state.empresaSelect == -1) {
      isValid = false;
      errors.empresaId = "Debe seleccionar una empresa"
    } else {
      this.state.rolesSelect.roles.every((elemento) => {
        if (elemento.checked) {
          errors.rolesSelect = null;
          isValid = valorOriginal;
          return false;
        } else {
          isValid = false;
          errors.rolesSelect = "Debe seleccionar al menos un rol";
          return true;
        }
      })
    }
    return { isValid, errors }
  }

  handleUsuarioSubmit = event => {
    event.preventDefault();
    const { isValid, errors } = this.validarCamposFormulario();
    if (isValid) {
      mostrarErroresEnFormulario({});
      this.setState({ openPantallaCarga: true });
      let rolEmpresa = [];
      if (esSesionAdmin()) {
        rolEmpresa = [this.state.rolesSelect]
      } else {
        rolEmpresa = this.obtenerRolesEmpresaAsignada(this.state.rolesxempresa)
      }
      const json = {
        nombres: this.state.nombres,
        apellidos: this.state.apellidos,
        identificador: this.state.identificador,
        cedula: this.state.cedula,
        email: this.state.email,
        usuario: this.state.usuario,
        rolesxempresa: rolEmpresa,
        celular: this.state.celular == null ? "" : this.state.celular,
        id: this.state.id,
        nroPersonalIps: this.state.nroPersonalIps == null ? "" : this.state.nroPersonalIps,
        nroTrabajoMtess: this.state.nroTrabajoMtess == null ? "" : this.state.nroTrabajoMtess,
        empresaId: obtenerIdEmpresa()
      };
      if (this.state.tipoAccion === "edit") {
        this.props.editarUsuario(json).then((respuesta) => {
          this.setState({ mensaje: respuesta.mensaje, severity: "success" });
          if (respuesta.error === true) {
            try {
              const errores = JSON.parse(respuesta.mensaje)
              this.setState(prevState => ({
                errors: {
                  ...prevState.errors,
                  usuario: errores.usuario,
                  identificador: errores.identificador,
                  cedula: errores.cedula,
                  email: errores.email,
                },
                openPantallaCarga: false
              }))
              mostrarErroresEnFormulario(this.state.errors)
            } catch (e) {
              this.setState({
                mostrarMensajeFlash: true,
                mensaje: respuesta.mensaje,
                severity: "danger",
                openPantallaCarga: false
              })
            }
          } else {
            if (this.state.uriFirma != null) {
              let username = this.state.usuario
              let formData = new FormData()
              formData.append("file", this.state.uriFirma)
              axios.post(URLService + "usuario/aparienciaFirma/" + username, formData, getAuthorizationHeaderUpload())
            }
            this.props.history.push({
              pathname: '/administracion/usuarios',
              state: {
                mostrarMensajeFlash: true,
                mensajeFlash: "Usuario editado exitosamente",
                mensajeFlashSeverity: 'exito'
              }
            })
          }
        }).catch(error => {
          this.setState({
            mostrarMensajeFlash: true,
            mensajeFlash: "Error inesperado al realizar la acción",
            mensajeFlashSeverity: "error",
            openPantallaCarga: false,
          });
        });
      } else if (this.state.tipoAccion === "add") {
        this.props
          .registrarUsuario(json, obtenerIdEmpresa())
          .then((respuesta) => {
            if (respuesta.error) {
              try {
                const errores = JSON.parse(respuesta.mensaje)
                this.setState(prevState => ({
                  errors: {
                    ...prevState.errors,
                    usuario: errores.usuario,
                    identificador: errores.identificador,
                    cedula: errores.cedula,
                    email: errores.email,
                  },
                  openPantallaCarga: false
                }))
                mostrarErroresEnFormulario(this.state.errors)
              } catch (e) {
                this.setState({
                  mensajeFlash: respuesta.mensaje,
                  mensajeFlashSeverity: 'error',
                  mostrarMensajeFlash: true,
                  openPantallaCarga: false,
                })
              }
            } else {
              if (this.state.uriFirma != null) {
                let username = this.state.username
                let formData = new FormData()
                formData.append("file", this.state.uriFirma)
                axios.post(URLService + "usuario/aparienciaFirma/" + username, formData, getAuthorizationHeaderUpload())
              }
              this.props.history.push({
                pathname: '/administracion/usuarios',
                state: {
                  mostrarMensajeFlash: true,
                  mensajeFlash: "Usuario agregado exitosamente",
                  mensajeFlashSeverity: 'exito'
                }
              })
            }

          }).catch(error => {
            this.setState({
              mostrarMensajeFlash: true,
              mensajeFlash: "Error inesperado al realizar la acción",
              mensajeFlashSeverity: "error",
              openPantallaCarga: false,
            });
          });
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }
  };

  componentDidMount() {

    configurarLimpiezaAutomatica()

    if (this.state.tipoAccion === "edit") {
      const { usuario } = this.props.location.state;
      this.setState({
        nombres: usuario.nombres,
        apellidos: usuario.apellidos,
        identificador: usuario.identificador,
        cedula: usuario.cedula,
        email: usuario.email,
        celular: usuario.celular == null ? "" : usuario.celular,
        usuario: usuario.usuario,
        id: usuario.id,
        nroPersonalIps: usuario.nroPersonalIps == null ? "" : usuario.nroPersonalIps,
        nroTrabajoMtess: usuario.nroTrabajoMtess == null ? "" : usuario.nroTrabajoMtess,
        titulo: "Datos del usuario: " + usuario.usuario
      });
      axios
        .get(URLService + "empresa/listarEmpresas", getAuthorizationHeader())
        .then((res) => {
          if (res.data.error == false) {
            this.setState({ empresas: res.data.datos });
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
      axios
        .get(
          URLService + "usuario/obtenerRolesUsuarioEdit/" + usuario.id,
          getAuthorizationHeader()
        )
        .then((res) => {
          if (res.data.error == false) {
            this.setState({
              rolesxempresa: res.data.datos,
            });
            if (!esSesionAdmin()) {
              this.setState({
                empresaSelect: res.data.datos.findIndex(
                  (elemento) => elemento.id == obtenerIdEmpresa()
                ),
                rolesSelect: this.state.rolesxempresa.find(
                  (elemento) => elemento.id == obtenerIdEmpresa()
                ),
              });
            }
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
      axios.get(URLService + "usuario/aparienciaFirma/" + usuario.id, getAuthorizationHeader())
        .then(res => {
          if (res.data.error !== true) {
            this.setState({
              urlFirma: "data:image/png;base64," + res.data
            })
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        })
    } else {
      axios
        .get(URLService + "empresa/listarEmpresas", getAuthorizationHeader())
        .then((res) => {
          if (res.data.error == false) {
            this.setState({ empresas: res.data.datos });
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
      axios
        .get(
          URLService + "usuario/obtenerRolesUsuarioEdit/" + "-1",
          getAuthorizationHeader()
        )
        .then((res) => {
          if (res.data.error == false) {
            this.setState({ rolesxempresa: res.data.datos });
          }
          if (!esSesionAdmin()) {
            this.setState({
              empresaSelect: res.data.datos.findIndex(
                (elemento) => elemento.id == obtenerIdEmpresa()
              ),
              rolesSelect: this.state.rolesxempresa.find(
                (elemento) => elemento.id == obtenerIdEmpresa()
              ),
            });
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
    }
  }

  handleInput = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };

  handleUploadAparienciaFirma = async (archivo) => {
    const resultadoAnalisis = await validarImagen(archivo)
    if (resultadoAnalisis.isValid) {
      Resizer.imageFileResizer(
        archivo,
        200, 150,
        "PNG",
        0, 0,
        (uri) => {
          this.setState({
            urlFirma: URL.createObjectURL(uri),
            uriFirma: uri,
            mensajeErrorAparienciaFirma: "",
          })
        },
        "file",
      )
    } else {
      this.setState({
        mostrarMensajeFlash: true,
        mensajeFlash: resultadoAnalisis.error,
        mensajeFlashSeverity: "error"
      })
    }
  }

  handleChangeEmpresa = (event) => {
    let empresaSelect = this.state.rolesxempresa.findIndex(
      (elemento) => elemento.id == event.target.value
    );
    if (this.props.sessionData.admin) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          empresa: null
        },
        empresaSelect: empresaSelect,
        rolesSelect: this.state.rolesxempresa[empresaSelect],
      }))
    } else {
      this.setState({
        empresaSelect: obtenerIdEmpresa(),
        rolesSelect: this.state.rolesxempresa.find(
          (elemento) => elemento.id == obtenerIdEmpresa()
        ),
      });
    }
  };

  rolesHijos = (rol) => {
    if (rol === "Firmar como Recursos Humanos (RRHH)") {
      return true;
    }
    return rol === "Firmar como Representante Legal";
  };

  chkclick = (event) => {
    let rolesxempresa = this.state.rolesxempresa;
    rolesxempresa[this.state.empresaSelect].roles.forEach((elemento) => {
      if (elemento.id == event.target.value) {
        elemento.checked = event.target.checked;
      }
    });
    this.setState({ rolesxempresa: rolesxempresa });

    let rolesSelect = this.state.rolesSelect;
    rolesSelect.roles.forEach((elemento) => {
      if (elemento.id == event.target.value) {
        elemento.checked = event.target.checked;
      }
    });
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        rolesSelect: null
      },
      rolesSelect: rolesSelect
    }))

  };

  onChangeMiembroActivo = (event) => {
    let rolesxempresa = this.state.rolesxempresa;
    rolesxempresa[this.state.empresaSelect].activo = event.target.checked;
    let rolesSelect = this.state.rolesSelect;
    rolesSelect.activo = event.target.checked;
    this.setState({
      rolesxempresa: rolesxempresa,
      rolesSelect: rolesSelect,

    });
  };

  mostrarErroresValidacion = (value) => {
    this.setState({ showValidacion: value });
  };

  render() {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={this.setBackButton}
                breadcrumbs={
                  [
                    { label: 'Usuarios', path: this.setBackButton },
                    { label: this.props.match.params.tipoAccion !== 'edit' ? 'Nuevo usuario' : 'Editar usuario', path: '' }
                  ]
                }
              />

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> {this.state.titulo ?? "Registrar nuevo usuario"}  </h1>
                  <p className="page-description"> Complete el siguiente formulario con los datos correspondientes </p>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container card">
              <div className="component-form">
                <div className="component-content">
                  <form ref={this.formRef} onSubmit={this.handleUsuarioSubmit} className="form container-sm">

                    <div className="form-group">
                      <input type="text" name="usuario" id="usuario" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.usuario} />
                      <label htmlFor="usuario" className="form-label"> Nombre de usuario </label>
                    </div>

                    <div className="form-group__inline">

                      <div className="form-group">
                        <input type="text" name="nombres" id="nombres" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.nombres} />
                        <label htmlFor="nombres" className="form-label"> Nombres </label>
                      </div>

                      <div className="form-group">
                        <input type="text" name="apellidos" id="apellidos" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.apellidos} />
                        <label htmlFor="apellidos" className="form-label"> Apellidos </label>
                      </div>


                      <div className="form-group">
                        <input type="text" name="cedula" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.cedula} />
                        <label htmlFor="cedula" className="form-label"> Cédula de identidad </label>
                      </div>

                      <div className="form-group">
                        <input type="text" name="identificador" id="identificador" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.identificador} />
                        <label htmlFor="identificador" className="form-label"> Identificador </label>
                      </div>

                      <div className="form-group">
                        <input type="text" name="celular" id="celular" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.celular} />
                        <label htmlFor="celular" className="form-label"> Nro. de telefono </label>
                      </div>

                      <div className="form-group">
                        <input type="text" name="nroPersonalIps" id="nroPersonalIps" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.nroPersonalIps} />
                        <label htmlFor="nroPersonalIps" className="form-label"> Nro. Personal IPS </label>
                      </div>

                      <div className="form-group">
                        <input type="text" name="nroTrabajoMtess" id="nroTrabajoMtess" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.nroTrabajoMtess} />
                        <label htmlFor="nroTrabajoMtess" className="form-label"> Nro. Trabajo MTESS </label>
                      </div>

                      <div className="form-group">
                        <input type="email" name="email" id="email" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.email} />
                        <label htmlFor="email" className="form-label"> Correo electrónico </label>
                      </div>
                    </div>

                    {esSesionAdmin() ? (
                      <div>
                        <div className="form-group">
                          <select className="form-select" name="empresaId" id="empresaId" placeholder="" onChange={this.handleChangeEmpresa}>
                            <option key="" value="" selected></option>
                            {this.state.empresas.map((elemento) => (
                              <option key={elemento.id} value={elemento.id}>
                                {elemento.nombre}
                              </option>
                            ))}
                          </select>
                          <label htmlFor="empresaId" className="form-label"> Seleccionar empresa </label>
                        </div>
                      </div>

                    ) : null}

                    {this.state.empresaSelect != -1 && admin() ? (
                      <div className="form-group">
                        <input type="checkbox" className="form-check" name="estado" id="estado" onChange={this.onChangeMiembroActivo} checked={this.state.rolesSelect.activo} />
                        <label htmlFor="estado" className="check-label"> Miembro activo </label>
                      </div>) : null}

                    <hr />

                    <span className="form-subtitle"> Roles del perfil </span>
                    <div className="form-group__inline" data-field="rolesSelect">
                      <div className="inline-group">
                        {this.state.empresaSelect != -1
                          ? this.state.rolesSelect.roles.map((elemento) => (
                            <div key={elemento.id} className="form-group">
                              <input type="checkbox" id={elemento.id} checked={elemento.checked} className="form-check" value={elemento.id} onClick={this.chkclick} />
                              <label htmlFor={elemento.id} className="check-label"> {elemento.nombre} </label>
                            </div>
                          ))
                          : null}
                      </div>
                    </div>

                    <hr />

                    {aparienciaFirmaUsuario &&
                      <div className="component-carga-apariencia">

                        <h3 className="form-subtitle"> Apariencia de Firma </h3>
                        <p className="form-description"> Selecciona el archivo de imagen como apariencia de firma </p>
                        <div className="container-flex center-content">
                          {
                            this.state.urlFirma &&
                            <div className="col">
                              <span className="form-midtitle"> Apariencia actual </span>
                              <div className="signature-area">
                                <img id="aparienciaFirmaImg" src={this.state.urlFirma} className="img-fluid" alt="apariencia_firma_actual" />
                              </div>
                            </div>
                          }

                          <div className="col">
                            <span className="form-midtitle"> Seleccionar imagen para apariencia de firma </span>
                            <div className="carga-documento-section">

                              <div className="carga-documento-content">
                                <DropzoneComponent onFileSelected={this.handleUploadAparienciaFirma} archivos_soportados={[".png", ".jpg"]} />
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    }
                    <div className="form-actions">
                      <button type="submit" className="btn-medium btn-primary"> Continuar </button>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </div >
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  registrarUsuario: (value) => dispatch(registrarUsuario(value)),
  editarUsuario: (value) => dispatch(editarUsuario(value)),
});
const mapStateToProps = (state) => ({
  sessionData: state.sessionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Usuario);
